export const KEYS_TO_FILTERS = [
  "name",
  "jobTitle",
  "location.city",
  "location.state",
  "location.country",
]
